import { render, staticRenderFns } from "./formAddMiniSite.vue?vue&type=template&id=5fc8eb71&scoped=true"
import script from "./formAddMiniSite.vue?vue&type=script&lang=js"
export * from "./formAddMiniSite.vue?vue&type=script&lang=js"
import style0 from "./formAddMiniSite.vue?vue&type=style&index=0&id=5fc8eb71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc8eb71",
  null
  
)

export default component.exports